import React from "react";
import { Button, Form, Modal } from "react-bootstrap";

import "./ProductShareModal.scss";
import "./ProductShareViaSmsModal.scss";
import LoadMask from "../../../../components/LoadMask";
import Item from "../../../../models/Item";
import CatalogContext from "../../../../contexts/CatalogContext";

/**
 *
 * @param {String} initialPhoneNumber
 * @param {String} initialMessage
 * @param {Function} onClose
 * @param {Function} onSave
 */
export default function ProductShareViaSmsModal({
	phoneNumber: initialPhoneNumber,
	message: initialMessage,
	items,
	onClose,
	onSave,
}) {
	const [errors, setErrors] = React.useState([]);
	const [phoneNumber, setPhoneNumber] = React.useState(initialPhoneNumber);
	const [message, setMessage] = React.useState(initialMessage);
	const [processing, setProcessing] = React.useState(false);
	const touched = React.useRef();
	const phoneInputRef = React.useRef();
	const [catalog] = React.useContext(CatalogContext);

	// MOUNT
	React.useEffect(() => {
		phoneInputRef.current.focus();
	}, []);

	const inner_on_close = () => {
		if (!phoneNumber) {
			do_close();
		}
	}

	const do_close = () => {
		onClose?.();
	}

	const save = async () => {
		setProcessing(true);
		setErrors([]);

		try {
			const result = await Item.Call({
				name: "Share_Via_Text",
				payload: {
					phone_number: phoneNumber,
					message: (message ? message + "\n\n" : "") + Item.Make_Share,
					media_url: Item.Make_Share_HTML_Url(catalog.account.code, items),
				}
			});

			if (!result.success) {
				throw new Error(result.result);
			}

			onSave?.(result.result);
			do_close();
		}
		catch (e) {
			console.warn("Failed to send text", e);
			setProcessing(false);
			setErrors(["There was a problem sending the text message."]);
		}
	}

	const onKeyUp = e => {
		if (e.key.toLowerCase() === "escape") {
			key_escape();
		}
		else if (e.key.toLowerCase() === "enter" && !(e.target instanceof HTMLTextAreaElement)) {
			save();
		}
		touched.current = true;
	}

	const key_escape = () => {
		if (!touched.current) {
			onClose?.();
		}
	}


	return (
		<Modal
			className={"_boss dialog sms-input-dialog"}
			show={true}
			onHide={inner_on_close}
			onEscapeKeyDown={key_escape}
			centered
			backdrop
		>
			<Modal.Header>
				<Modal.Title>Share Via Text | {items.length} Item{items.length !== 1 ? "s" : ""}</Modal.Title>
				<button className="btn-close" area-label="Close" onClick={do_close}></button>
			</Modal.Header>
			<Modal.Body>
				<LoadMask show={processing} />
				<section data-component="ProductShareViaSmsModal">
					<section id="info-form">
						<Form.FloatingLabel label="Phone Number *">
							<Form.Control
								ref={phoneInputRef}
								autoComplete="off"
								value={phoneNumber ?? ""}
								type="tel"
								placeholder=""
								onChange={e => setPhoneNumber(e.target.value)}
								onKeyDownCapture={onKeyUp}
							/>
						</Form.FloatingLabel>

						<Form.FloatingLabel label="Message">
							<Form.Control
								as="textarea"
								autoComplete="off"
								value={message ?? ""}
								placeholder=""
								onChange={e => setMessage(e.target.value)}
								onKeyDownCapture={onKeyUp}
							/>
						</Form.FloatingLabel>
					</section>
					{errors?.length !== 0 && (
						<section id="errors">
							{errors.map((err, idx) => <div key={idx}>{err}</div>)}
						</section>
					)}
				</section>
			</Modal.Body>
			<Modal.Footer>
				<Button className="btn btn-primary" onClick={save}>Save</Button>
			</Modal.Footer>
		</Modal>
	)
}